import React, { Component } from "react";
import GenAIFlipbookMainContent from "../FunctionalComp/FlipbookContent/GenAIFlipbookMainContent";
// import GenAIFlipbookMainContent from "../FunctionalComp/FlipbookContent/GenAIFlipbookMainContent";

class GenAIFlipbookMain extends Component {
  render() {
    return (
      <div>
        {/* <FlipbookMainContent /> */
        <GenAIFlipbookMainContent />
        
        }
        
      </div>
    );
  }
}

export default GenAIFlipbookMain;
